exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".featureWrapper[max-width~=\"685px\"] .buttonResponsive{display:none}.featureOverlayHeader[max-width~=\"670px\"] h2{font-size:1.28571429rem}.featureOverlayHeader[min-width~=\"670px\"] h2{font-size:1.71428571rem}.tabsBarWrapper[max-width~=\"447px\"] .tabDropdown{min-width:10em}.tabsBarWrapper[max-width~=\"220px\"] .tabDropdown{min-width:auto}", ""]);

// exports
